import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { type RichTranslationValues } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '../RichText';

export interface LegalParagraphProps {
  readonly tx: MessageKey;
  readonly className?: string | undefined;
  readonly values?: RichTranslationValues | undefined;
}

const LegalParagraph = ({
  tx: text,
  className = '',
  values,
}: LegalParagraphProps) => {
  const copy = values ? (
    <RichText messageKey={text} tValues={values} />
  ) : (
    <RichText messageKey={text} />
  );

  return (
    <Typography Element="p" className={className}>
      {copy}
    </Typography>
  );
};

export default LegalParagraph;
